<template>
    
        <v-container class="">
            <v-row class="">
                <html>
	<head>
		<meta content="text/html; charset=UTF-8" http-equiv="content-type">
			
		</head>
		<body class="c3 px-4">
			<h1 class="c6">
				<span class="c1 c7">HEALTHYALWAYS REFUND POLICY</span>
			</h1>
			<p class="c0 c4">
				<span class="c5"></span>
			</p>
			<p class="c0">
				<span class="c1">Video Session Quality:</span>
				<span class="c2">&nbsp;The quality of the video session depends on the quality of the Internet connection, web cam and audio facilities of both the patient and healthcare provider. It is the responsibility of the patient to ensure that the performance and quality of the equipment and connection used are optimal for doing video calls online. Video Consultations that fail on account of poor equipment and connectivity will not be rescheduled for free. Nor will there be any refund of payment.</span>
			</p>
			<p class="c0">
				<span class="c1">Video Session Privacy, Security &amp; Etiquette:</span>
				<span class="c2">&nbsp;It is required that the patient prepares ahead of time to participate in the Video Consultation, in a quiet and private place, where only the patient is present in the room where the video session is being held. For elderly or disabled patients who require help to participate in the video, a caregiver may be present. There must be no audio/video recording of the video session by the patient. It is necessary that the patient (and any caregiver) act with proper decorum in speech and action during the video consultation. Failure to comply with these requirements can result in termination of the video session with no refund or rescheduling of the consultation.</span>
			</p>
			<p class="c0">
				<span class="c2">Subscriptions and other payments are been managed and paid for online through the Subscription interface by the Customer, who can choose to subscribe on a monthly or annual plan. In some cases subscriptions are purchased by Customers through other subscription order mechanisms. Though all optional add-ons to the Virtual Practice require an active Virtual Practice subscription to function, the subscription period of add-on itself, is independent of the subscription period of the associated Virtual Practice, and depends on when the add-on was purchased. Any unexpected change in app store policies affecting the ability to publish custom mobile apps in the Customer&rsquo;s account will not result in a refund in the subscription charge associated with the custom mobile app.</span>
			</p>
			<p class="c0 c4">
				<span class="c2"></span>
			</p>
			<p class="c0">
				<span class="c2">All subscriptions automatically renew at the end of the billing cycle for the upcoming subscription periods equal to the preceding subscription period; and the per Team User pricing during any automatic renewal term will be based on the number of active Team User accounts at the point of renewal. All subscription payments are paid forward for the upcoming subscription term. Failure to pay the subscription fees on time will result in your Virtual Practice account being deactivated. Deactivated accounts can be reactivated by making the necessary subscription payment.</span>
			</p>
			<p class="c0 c4">
				<span class="c2"></span>
			</p>
			<p class="c0">
				<span class="c2">HealthyAlways reserves the right to change plans and pricing at any time. The changes will be notified either by email to all existing subscribers and also on the website. If on a paid plan, you can upgrade/downgrade your account at any time. You can upgrade by paying the incremental cost. If your account is upgraded during a billing cycle the increased charges will be calculated on pro-rata basis. Downgrading of account can cause reduction in features or loss of access to content in your account and will not result in refunds. HealthyAlways will not be responsible for operational limitations due to downgrading of an account subscription. All information in your billing account should be current and accurate. All billing related mails will be sent to the email address that you have provided. All charges collected for a billing cycle are non-refundable, irrespective of account cancellation, termination or downgrade. Late payments will result in suspension of service until payments are made.</span>
			</p>
			<p class="c0" id="h.gjdgxs">
				<span class="c2">In the case of terminations with cause, there will be no refund of subscription payments, for the period between date of termination and date of expiry of the current subscription. HealthyAlways also retains the right to pursue any action to remedy breach of these Terms of Use.</span>
			</p>
		</body>
	</html>
            </v-row>
        </v-container>
</template>

<script>
    export default {
        name: "RefundPolicy",
        mounted() {
            
        },
        data() {
            return {
                
            }
        },
        methods: {
           
        },
    }
</script>
<style scoped type="text/css">@import url('https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLVumN3ATOVc2BoeDKcwJhFTljiSzuFEcjsip7pjNdcnF');
ol {
	margin: 0;
	padding: 0
}

table td,
table th {
	padding: 0
}

.c2 {
	color: #000000;
	font-weight: 400;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 10pt;
	font-family: "Calibri";
	font-style: normal
}

.c6 {
	padding-top: 24pt;
	padding-bottom: 0pt;
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

.c5 {
	color: #000000;
	font-weight: 400;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 11pt;
	font-family: "Calibri";
	font-style: normal
}

.c7 {
	color: #366091;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 14pt;
	font-family: "Cambria";
	font-style: normal
}

.c0 {
	padding-top: 0pt;
	padding-bottom: 10pt;
	line-height: 1.1500000000000001;
	orphans: 2;
	widows: 2;
	text-align: left
}

.c3 {
	background-color: #ffffff;
		
}

.c4 {
	height: 11pt
}

.c1 {
	font-weight: 700
}

.title {
	padding-top: 24pt;
	color: #000000;
	font-weight: 700;
	font-size: 36pt;
	padding-bottom: 6pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

.subtitle {
	padding-top: 18pt;
	color: #666666;
	font-size: 24pt;
	padding-bottom: 4pt;
	font-family: "Georgia";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	font-style: italic;
	orphans: 2;
	widows: 2;
	text-align: left
}

li {
	color: #000000;
	font-size: 11pt;
	font-family: "Calibri"
}

p {
	margin: 0;
	color: #000000;
	font-size: 11pt;
	font-family: "Calibri"
}

h1 {
	padding-top: 24pt;
	color: #366091;
	font-weight: 700;
	font-size: 14pt;
	padding-bottom: 0pt;
	font-family: "Cambria";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h2 {
	padding-top: 18pt;
	color: #000000;
	font-weight: 700;
	font-size: 18pt;
	padding-bottom: 4pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h3 {
	padding-top: 14pt;
	color: #000000;
	font-weight: 700;
	font-size: 14pt;
	padding-bottom: 4pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h4 {
	padding-top: 12pt;
	color: #000000;
	font-weight: 700;
	font-size: 12pt;
	padding-bottom: 2pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h5 {
	padding-top: 11pt;
	color: #000000;
	font-weight: 700;
	font-size: 11pt;
	padding-bottom: 2pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h6 {
	padding-top: 10pt;
	color: #000000;
	font-weight: 700;
	font-size: 10pt;
	padding-bottom: 2pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}


html{
    overflow-y:auto;
}


</style>